import { IWarehouse } from '../interfaces/IWarehouse';
import { getDateTime } from '../helpers/date.helper';

export class WarehouseMapper {
  /**
   * Maps warehouse data to select options format
   */
  static toSelect(warehouses: IWarehouse[]) {
    return (warehouses || []).map((warehouse) => ({
      label: warehouse.name,
      value: String(warehouse.id),
    }));
  }

  /**
   * Maps warehouses to simple list format (id, name only)
   */
  static toList(warehouses: IWarehouse[]) {
    return (warehouses || []).map((warehouse) => ({
      id: warehouse.id,
      name: warehouse.name,
    }));
  }

  /**
   * Maps warehouses array to object with id as key
   */
  static toObject(warehouses: IWarehouse[]) {
    return (warehouses || []).reduce((acc, warehouse) => {
      acc[warehouse.id] = {
        id: warehouse.id,
        name: warehouse.name,
      };
      return acc;
    }, {} as Record<string, any>);
  }

  /**
   * Maps single warehouse from API to UI format
   */
  static toLocal(warehouse: IWarehouse): IWarehouse {
    if (!warehouse) return null;

    return {
      id: warehouse.id,
      externalId: warehouse.externalId,
      name: warehouse.name,
      code: warehouse.code || '',
      address: warehouse.address || '',
      city: (warehouse as any).meta?.cityName || warehouse.city || '',
      country: warehouse.country || '',
      isActive: warehouse.isActive ?? true,
      phone: warehouse.phone || '',
      email: warehouse.email || '',
      notes: warehouse.notes || '',
      capacity: warehouse.capacity || 0,
      manager: warehouse.manager || '',
      companyId: warehouse.companyId || null,
      cityId: warehouse.cityId ?? (warehouse as any).city_id ?? null,
      stateId: warehouse.stateId ?? (warehouse as any).state_id ?? null,
      createdAt: warehouse.createdAt 
        ? getDateTime(warehouse.createdAt)
        : undefined,
      updatedAt: warehouse.updatedAt
        ? getDateTime(warehouse.updatedAt)
        : undefined,
    };
  }

  /**
   * Maps warehouses array to UI format
   */
  static toListUI(warehouses: IWarehouse[]): IWarehouse[] {
    return (warehouses || []).map((warehouse) => this.toLocal(warehouse));
  }
}

